/*
 * @Author: your name
 * @Date: 2020-05-05 16:36:02
 * @LastEditTime: 2020-05-20 22:58:23
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /vue-basic-ui/src/index.js
 */
import zyTable from '../packages/table/index.js'
console.log('222')

const components = [
  zyTable
]

const install = function (Vue) {
  components.forEach(component => {
    Vue.component(component.name, component)
  })
}

export default {
  version: '1.0.4',
  zyTable,
  install
}



// WEBPACK FOOTER //
// ./src/index.js